"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyBalance = void 0;
exports.emptyBalance = { id: 1, token: { template: { contract: { decimals: 18, symbol: "ETH" } } } };
//# sourceMappingURL=empty-balance.js.map